<template>
  <artmisads-modal v-model:open="visible" :title="$t('seller.publishersPage.viewPartnershipHistory')" :width="600" :footer="null"
    @cancel="handleClose">
    <div class="history-modal">
      <div class="brand-info">
        <div class="info-item">
          <div class="info-item-content">
            <div class="label">{{ $t('seller.publishersPage.labelBrandColon') }}</div>
            <span class="value">{{ brandInfo?.amazonBrandName }}</span>
          </div>
        </div>
        <div class="info-item" v-if="typeInfo === 'associateBrands'">
          <div class="info-item-content">
            <div class="label">{{ $t('seller.publishersPage.labelMarketplaceColon') }}</div>
            <span class="value">{{ brandInfo?.marketplace ? brandInfo.marketplace : '--' }}</span>
          </div>
        </div>
        <div class="info-item" v-if="typeInfo === 'publishers'">
          <div class="info-item-content">
            <div class="label">{{ $t('seller.publishersPage.labelPublisherColon') }}</div>
            <span class="value">{{ brandInfo?.creatorName ? brandInfo.creatorName : '--' }}</span>
          </div>
        </div>
      </div>
      <artmisads-table :loading="loading" :columns="columns" :data-source="dataList" row-key="id" :pagination="{
        total: tableTotal,
        current: params.page,
        pageSize: params.size,
        showTotal: (total) => $t('seller.publishersPage.paginationTotal', { total }),
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200']
      }" :change="onChangePage">
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'date'">
            {{ record.startDateStr }} ~ {{ record.endDateStr }}
          </template>
          <template v-if="column.dataIndex === 'commissionRate'">
            {{ text }}%
          </template>
        </template>
      </artmisads-table>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { associateCentralApi } from '~/server/index'
import { publishersApi } from '@/server'
import { message } from 'ant-design-vue'

const { t } = useI18n()
const visible = ref(false)
const brandId = ref('')
const publisherId = ref('')
const brandInfo = ref({})
const loading = ref(false)
const typeInfo = ref('')
const columns = computed(() => [
  {
    title: t('seller.publishersPage.historyColDate'),
    dataIndex: 'date',
  },
  {
    title: t('seller.brandsPage.colCommission'),
    dataIndex: 'commissionRate',
  },
])
const dataList = ref([])
const tableTotal = ref(0)
const params = ref({
  page: 1,
  size: 10
})
const showModal = async (info, type) => {
  typeInfo.value = type
  if (type === 'associateBrands') {
    params.value.page = 1
    params.value.size = 10
    brandId.value = info.brandId
    try {
      await getAssociateBrandsList()
      visible.value = true
    } catch (error) {
      message.error(error)
    }
  }
  if (type === 'publishers') {
    params.value.page = 1
    params.value.size = 10
    console.log(info,'info')
    brandId.value = info.brandId
    publisherId.value = info.publisherId
    try {
      await getPublishersList()
      visible.value = true
    } catch (error) {
      message.error(error)

    }
  }


}
const getAssociateBrandsList = async () => {
  loading.value = true
  const res = await associateCentralApi.getAssociateBrandDetail({ brandId: brandId.value, page: params.value.page, size: params.value.size })
  const { success, error, data } = res
  if (success) {
    dataList.value = data.commissionDetail
    brandInfo.value = data.brandVO
    brandInfo.value.marketplace = data.marketplace

    tableTotal.value = data.total
  } else {
    message.error(error)
  }
  loading.value = false
}
const getPublishersList = async () => {
  loading.value = true
  const res = await publishersApi.getPublisherHistory({ publisherId: publisherId.value, brandId: brandId.value, page: params.value.page, size: params.value.size })
  const { success, error, data } = res
  if (success) {
    dataList.value = data.commissionDetail
    tableTotal.value = data.total
    brandInfo.value = {
      ...data.brandVO,
      ...data.publisherVO
    }
  } else {
    message.error(error)
  }
  loading.value = false
}
const closeModal = () => {
  visible.value = false
  brandInfo.value = {}
  dataList.value = []
}
const onChangePage = ({ current, pageSize }) => {
  params.value.page = current
  params.value.size = pageSize
  if (typeInfo.value === 'associateBrands') {
    getAssociateBrandsList()
  }
  if (typeInfo.value === 'publishers') {
    getPublishersList()
  }
}
const handleClose = () => {
  closeModal()
}

defineExpose({
  showModal
})
</script>

<style scoped lang="less">
.history-modal {
  .brand-info {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;

    .info-item-content {
      border-left: 3px solid #7653DA;
      padding-left: 12px;
    }

    .info-item:last-child {
      margin-left: 12px;
    }

    .info-item:first-child {
      margin-right: 12px;
    }

    .info-item {

      margin-bottom: 8px;
      border-radius: 8px;
      background: #50408014;
      flex: 1;
      padding: 12px 12px 12px 0;

      .label {
        color: #0f0629;
        font-family: "Sora";
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.3px;
        opacity: 0.7;
      }

      .value {
        color: #0f0629;
        font-family: "Sora";
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px;
        letter-spacing: 0.5px;
        opacity: 0.9;
      }
    }
  }


}
</style>